module.exports = __webpack_public_path__ + "static/img/map_2.a04fda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/map_2.png
// module id = JXYb
// module chunks = 1